// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
export default function keyInObj(value, key, obj) {
  return key in obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_keyInObj.js
// module id = 163
// module chunks = 0